export default "__VITE_ASSET__59a05306__"